import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { Category } from '@/types';

interface CategoryCardProps {
  category: Category;
}

export function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/${category.slug}`}
      className="group block p-6 rounded-xl border bg-card hover:border-primary/50 hover:shadow-sm transition-all"
    >
      <div className="flex items-start gap-4">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
            {category.name}
          </h3>
          {category.description && (
            <p className="mt-1 text-sm text-muted-foreground line-clamp-2">
              {category.description}
            </p>
          )}
          {typeof category.article_count === 'number' && (
            <p className="mt-2 text-xs text-muted-foreground">
              {category.article_count} {category.article_count === 1 ? 'article' : 'articles'}
            </p>
          )}
        </div>
        <ChevronRight className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
      </div>
    </Link>
  );
}
